import { render, staticRenderFns } from "./CreateAct.vue?vue&type=template&id=a13b5f22&scoped=true&"
import script from "./CreateAct.vue?vue&type=script&lang=js&"
export * from "./CreateAct.vue?vue&type=script&lang=js&"
import style0 from "./CreateAct.vue?vue&type=style&index=0&id=a13b5f22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a13b5f22",
  null
  
)

export default component.exports